import React from 'react';
import { Link } from 'react-router-dom';
import logo from "../img/logo.png";
import awsPartner from "../img/aws-partner.png";
import awsSoftware from "../img/aws-software.png";

const Footer = () => {
    return ( 
        <footer id="footer" data-bg="white" className="aos-init">
            <div className="container">
                <div className="row">
                    <section data-padding="xstop" className="aos-init">
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="ctabox-element--center--round--light">
                                        <div className="text">
                                            <h2>Get in touch to see how we can help you.</h2>
                                            <Link to="/contact" className="btn--big--border--light--round" target="_self">Contact Us</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <div className="row main-wrapper">
                    <div className="col-12 col-md-4">
                        <div className="logo-footer">
                            <div className="image--small">
                                <img src={logo} alt="" />
                            </div>
                            <div className="imggroups">
                                <div className="image--small">
                                    <img src={awsPartner} alt="" />
                                </div>
                                <div className="image--small">
                                    <img src={awsSoftware} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 offset-md-2">
                        <div className="row">
                            <div className="col-6 col-md-6">
                                <div className="list-element--text">
                                    <h6>Pages</h6>
                                    <ul>
                                        <li><Link to={`/`}>Home</Link></li>
                                        <li><Link to={`/contact`}>Contact</Link></li>
                                        <li><a href={`https://www.amazondigitaloffice.com/login`}>Log in</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-6 col-md-6">
                                <div className="info-footer">
                                    <h6>Contact</h6>
                                    <p>
                                        <b style={{fontWeight: 501}}>England Office</b>
                                        <br />
                                        <span>1 Medway Ct, Cranfield,</span>
                                        <br />
                                        <span> Wharley End, Bedford MK430FQ</span>
                                        <br /> <br />
                                        <b style={{fontWeight: 501}}>South Africa Office</b>
                                        <br />
                                        <span>Unit 59 , Stone Manor,<br /> 46 North Road Morningside 2196 Johannesburg</span>
                                        <br />
                                        
                                    </p>
                                    <div className="social-element--small">
                                        <span>info@signtechforms.com</span>
                                        <ul>
                                            <li><a href="https://www.linkedin.com/company/signtech-forms"><i className="fab fa-linkedin-in"></i></a></li>
                                            <li><a href="mailto:expert@signtechforms.com?subject=Ask%20an%20Expert"><i className="far fa-envelope"></i></a></li>
                                            <li><a href="https://www.facebook.com/signtechforms"><i className="fab fa-facebook-f"></i></a></li>
                                            <li><a href="https://twitter.com/SignTechForms"><i className="fab fa-twitter"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 down border">
                        <div className="wrapper justify-content-md-between align-items-md-center">
                            <div className="link">
                                <div className="list-element--text--inline">
                                    <ul>
                                        <li><a href="https://amazondigitaloffice.com/saas">saas policy</a></li>
                                        <li><a href="https://amazondigitaloffice.com/privacy">privacy policy</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="text">
                                <p>© 2023 <a href="https://www.signtechforms.com" className="simple" target="_blank">SignTech Paperless Solution</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
 
export default Footer;